import React, { useEffect, useRef, useState } from "react";
import { LuSearch } from "react-icons/lu";

const SEARCH_WHILE_TYPING_DELAY_MS = 400;

const SearchSection: React.FC<{
  onSearch: (searchInput: string) => void;
  // Also calls onSearch shortly after the user stops typing, not only on
  // Enter / the search icon.
  searchWhileTyping?: boolean;
  isFilterMode?: boolean;
  onSliderClicked?: () => void;
  noFilter?: boolean;
  className?: string;
  placeholder?: string;
  inputId?: string; // lets a visible <label htmlFor> point at the input
}> = ({ onSearch, searchWhileTyping, className, placeholder = "Search", inputId }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;

  useEffect(() => {
    if (!searchWhileTyping) return;
    const timer = setTimeout(() => onSearchRef.current(searchTerm), SEARCH_WHILE_TYPING_DELAY_MS);
    return () => clearTimeout(timer);
  }, [searchTerm, searchWhileTyping]);

  return (
      <section className={`w-full relative ${className}`}>
        <LuSearch className="absolute text-3xl text-black41 top-1.5 left-3 p-1 cursor-pointer" onClick={() => onSearch(searchTerm)} />
        <input
          className="border border-[#D9D9D9] focus:border-2 w-full pl-[50px] placeholder:text-[#898989] outline-none p-2 focus:py-[7px] rounded-full"
          value={searchTerm}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSearchTerm(e.target.value);
          }}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
              onSearch(searchTerm);
            }
          }}
          id={inputId}
          placeholder={placeholder}
          aria-label="Search projects"
        />
      </section>
  );
};

export default SearchSection;
